import { render, staticRenderFns } from "./InsuranceAuthorizationRecipeMedicForm.vue?vue&type=template&id=ab632942&scoped=true&"
import script from "./InsuranceAuthorizationRecipeMedicForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceAuthorizationRecipeMedicForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceAuthorizationRecipeMedicForm.vue?vue&type=style&index=0&id=ab632942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab632942",
  null
  
)

export default component.exports